export var sameDate = function (date1, date2) {
    return date1 && date1.getTime && date2 && date2.getTime && date1.getTime() === date2.getTime();
};
